//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
/* eslint-disable no-lonely-if */
import {
  ref, computed, onMounted,
} from '@vue/composition-api'
import { addPayPremiumVideo } from '@api'
import {
  mdiVideoOutline,
  mdiVideoOffOutline,
  mdiCrownOutline,
} from '@mdi/js'
import 'video.js/dist/video-js.css'
import { useUtils } from '@core/libs/i18n'
import { useRouter, formatCurrency, isDev } from '@core/utils'
import { capitalizateText } from '@core/utils/filter'
import { success } from '@/@core/utils/toasted'
import moment from 'moment'
import themeConfig from '@themeConfig'
import useVideoData from '@core/utils/useVideoData'

import CheckoutPay from '@/views/video-checkout/components/CheckoutPay.vue'
import useCryptoJs from '@core/utils/useCryptoJs'

export default {
  components: {
    CheckoutPay,
  },
  setup() {
    const { t } = useUtils()
    const { router } = useRouter()
    const { videoData, currentVideoData, updateVideoData } = useVideoData()
    const { userData, decryptData, encrypt } = useCryptoJs()

    const isDialogPay = ref(false)
    const loginForm = ref(null)
    const itemSelected = ref(0)
    const paymentMethodsParams = ref([])

    const initPrices = ref([
      {
        value: 0,
        format: 'usd',
        hour: 1,
        minutes: 60,
        text: '60 Min',
        show: true,
      },
      {
        value: 0,
        format: 'usd',
        hour: 1.5,
        minutes: 90,
        text: '90 Min',
        show: true,
      },
      {
        value: 0,
        format: 'usd',
        hour: 2,
        minutes: 120,
        text: '120 Min',
        show: true,
      },
      {
        value: 0,
        format: 'usd',
        hour: 0.08,
        minutes: 5,
        text: '5 Min',
        show: isDev.value,
      },
    ])
    const prices = computed(() => initPrices.value.filter(e => e.show))
    const selectedPrice = computed(() => initPrices.value.at(itemSelected.value).value)
    const selectedformat = computed(() => initPrices.value.at(itemSelected.value).format)
    const selectedTime = computed(() => initPrices.value.at(itemSelected.value).minutes)

    const openUpdatePay = async val => {
      isDialogPay.value = val
    }

    const payOrderVideo = async body => {
      const encryptInfo = encrypt(body)
      const respPay = await addPayPremiumVideo({ info: encryptInfo })
      if (respPay.ok) {
        success(respPay.message)
        const hash = respPay.data.share_video_url.split('/r/')[1]
        videoData.value.video.share_video_url = respPay.data.share_video_url
        await updateVideoData(videoData.value)
        router.replace({ name: 'recording', params: { hash } })
      }
    }

    const onPay = async cardInfo => {
      const body = {
        user_id: userData.value && userData.value.user_id ? userData.value.user_id : null,
        video_id: null,
        video_order_id: videoData.value.video ? videoData.value.video.video_order_id : null,
        video_time: selectedTime.value,
        card_info: cardInfo,
      }
      await payOrderVideo(body)
    }

    const formatVideoDay = videoDate => moment(`${videoDate}`, 'YYYY-MM-DD hh:mm').format('dddd HH:mm')
    const formatVideoMonth = videoDate => moment(`${videoDate}`, 'YYYY-MM-DD hh:mm').format('MMM DD')

    onMounted(() => {
      Object.assign(videoData.value, currentVideoData.value)
      if (videoData.value.video) {
        initPrices.value = initPrices.value.filter(e => {
          if (videoData.value.video.valid_minutes.includes(e.minutes) || e.minutes === 5) return true

          return false
        })

        const videoPrice = videoData.value.video.hourly_price_2 ? videoData.value.video.hourly_price_2 : videoData.value.video.hourly_price
        const videoPriceFormat = videoData.value.video.hourly_price_2 ? 'eur' : 'usd'

        initPrices.value = initPrices.value.map(e => ({
          ...e,
          value: e.hour * videoPrice,
          format: videoPriceFormat,
        }))
      }

      if (videoData.value.paymentMethodsParams) {
        if (typeof (videoData.value.paymentMethodsParams) === 'string') paymentMethodsParams.value = decryptData(videoData.value.paymentMethodsParams)
        else paymentMethodsParams.value = videoData.value.paymentMethodsParams
      }

      const newPaymentMathod = {
        id: 0,
        last_4: null,
        exp_month: null,
        exp_year: null,
        brand: 'Add new card',
        exp_date_str: null,
      }
      if (paymentMethodsParams.value.legth) {
        const finded = paymentMethodsParams.value.find(e => e.id === 0)
        if (!finded) paymentMethodsParams.value.unshift(newPaymentMathod)
      } else paymentMethodsParams.value.unshift(newPaymentMathod)
    })

    return {
      // data
      userData,
      isDialogPay,
      loginForm,
      itemSelected,
      videoData,
      prices,
      selectedPrice,
      selectedformat,
      paymentMethodsParams,

      // methods
      formatCurrency,
      formatVideoDay,
      formatVideoMonth,
      openUpdatePay,
      onPay,
      capitalizateText,

      // themeConfig
      appLogoTitle: themeConfig.app.logoTitle,

      t,

      icons: {
        mdiVideoOutline,
        mdiVideoOffOutline,
        mdiCrownOutline,
      },
    }
  },
}
